import styles from "./FeeTier.module.css"
import { RiArrowDownSLine } from "react-icons/ri";

const FeeTier = () => {
  return (
      <div className={styles.fee_tier_container}>
          <div className={styles.fee_tier}>
              <span>Current fee tier: 0.5%</span>
              <RiArrowDownSLine  size={27} />{" "}


          </div>
          <div className={styles.apr}>Est.APR | 35.65%</div>
    </div>
  )
}

export default FeeTier